import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WavixService {

  constructor(private http: HttpClient) { }

  wavix_phone_validation(
    phone_number: any,
  ): Observable<any> {

    const params = {
      phone_number: phone_number,
      type: "format",
      appid: "63783a8081b2b15ff0277872ffec4a202f84174afe596b34eab8510d2fc894c8",
    }
    return this.http.get('https://api.wavix.com/v1/validation', { params });

  }
}
